import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function TermsAndConditions() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Link to="/">
          <Button variant="ghost" size="sm" className="mb-6">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </Link>

        <div className="bg-card border border-border rounded-lg p-8 shadow-card">
          <h1 className="font-display text-3xl font-bold text-foreground mb-2">Terms and Conditions</h1>
          <p className="text-muted-foreground mb-8">Last updated: January 2025</p>

          <div className="prose prose-sm max-w-none space-y-6 text-foreground">
            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">1. Introduction</h2>
              <p className="text-muted-foreground">
                Welcome to La Olla Restaurant ("we," "our," or "us"). These Terms and Conditions govern your use of our website and reservation services located at amayascorcovado.com (the "Service"). By accessing or using our Service, you agree to be bound by these Terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">2. Reservation Services</h2>
              <p className="text-muted-foreground mb-2">
                Our Service allows guests to make meal reservations at La Olla Restaurant. By making a reservation, you agree to:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-1">
                <li>Provide accurate and complete information</li>
                <li>Honor your reservation or cancel at least 2 hours before the meal time</li>
                <li>Pay for all meals and services consumed during your visit</li>
                <li>Notify us of any dietary requirements or allergies in advance</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">3. Pricing and Payment</h2>
              <p className="text-muted-foreground mb-2">
                All prices are listed in US Dollars (USD). Current meal prices are:
              </p>
              <ul className="list-disc pl-6 text-muted-foreground space-y-1">
                <li>Breakfast: $12.00 per person</li>
                <li>Lunch: $15.00 per person</li>
                <li>Dinner: $18.00 per person</li>
                <li>Room Service: Additional $2.50 per person</li>
              </ul>
              <p className="text-muted-foreground mt-2">
                Payment is due by 8:00 PM the night before your departure date. We accept cash (USD or Costa Rican Colones), credit cards (Visa, MasterCard), PayPal, and Sinpe Móvil.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">4. Cancellation Policy</h2>
              <p className="text-muted-foreground">
                Reservations may be cancelled or modified up to 2 hours before the scheduled meal time at no charge. Cancellations made less than 2 hours before the meal time may be subject to charges. No-shows may be charged the full meal price.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">5. Room Service</h2>
              <p className="text-muted-foreground">
                Room service is available for an additional fee of $2.50 per person. Meals will be delivered to your cabin at the scheduled meal time. Please ensure someone is available to receive the delivery.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">6. Dietary Requirements</h2>
              <p className="text-muted-foreground">
                We accommodate vegetarian, vegan, and gluten-free dietary requirements. Please inform us of any allergies or special dietary needs when making your reservation. While we take all precautions, we cannot guarantee a completely allergen-free environment.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">7. Limitation of Liability</h2>
              <p className="text-muted-foreground">
                La Olla Restaurant shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services. Our total liability shall not exceed the amount paid for the services in question.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">8. Intellectual Property</h2>
              <p className="text-muted-foreground">
                All content on this website, including text, graphics, logos, and images, is the property of La Olla Restaurant and is protected by copyright laws.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">9. Governing Law</h2>
              <p className="text-muted-foreground">
                These Terms shall be governed by and construed in accordance with the laws of Costa Rica. Any disputes arising from these Terms shall be resolved in the courts of Costa Rica.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">10. Changes to Terms</h2>
              <p className="text-muted-foreground">
                We reserve the right to modify these Terms at any time. Changes will be effective immediately upon posting to the website. Your continued use of the Service constitutes acceptance of the modified Terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3">11. Contact Information</h2>
              <p className="text-muted-foreground">
                For questions about these Terms and Conditions, please contact us at:
              </p>
              <div className="mt-2 text-muted-foreground">
                <p><strong className="text-foreground">La Olla Restaurant</strong></p>
                <p>Drake Bay, Osa Peninsula</p>
                <p>Puntarenas, Costa Rica</p>
                <p>Email: info@amayascorcovado.com</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
